/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import { SelectItem } from '../../../../shared/ModalSelectField';
import { FindingSuggestionsFilters } from './findingSuggestionsQueryParams';
import { useAppDispatch } from '../../../../core/store';
import { ModalMultiSelectField } from '../../../../shared/ModalMultiSelectField';
import { fetchRegions, selectIsFetchingRegions, selectRegions } from '../../store/findingSuggestionsSlice';

interface RegionMultiSelectFieldProps {
  filters: FindingSuggestionsFilters;
  defaultValue?: string[];
  editable?: boolean;
  onUpdate?: (brand: string[]) => void;
}

export function RegionMultiSelectField({
  filters,
  defaultValue = [],
  editable = false,
  onUpdate,
}: RegionMultiSelectFieldProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (editable) {
      dispatch(fetchRegions(filters));
    }
  }, [dispatch, editable, filters]);

  const regions = useSelector(selectRegions);
  const isFetching = useSelector(selectIsFetchingRegions);

  const toSelectItem = (item: string): SelectItem => {
    return {
      code: item,
      description: item,
    };
  };

  const toString = (item: SelectItem): string => {
    return item.code;
  };

  return (
    <ModalMultiSelectField
      icon='world'
      defaultValue={defaultValue != null ? defaultValue.map(v => toSelectItem(v)) : []}
      list={regions.map((b): SelectItem => toSelectItem(b) as SelectItem)}
      title={t('assessment.report.filters.regions') || ''}
      editable={editable}
      loading={isFetching}
      onUpdateValue={(selectedRegions: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedRegions.map(i => toString(i)));
        }
      }}
    />
  );
}
